import React from 'react'
import { partnerImage } from '../data'

export default function Partner() {
  return (
        <div className="row justify-content-center">
            {partnerImage.map((item,index)=>{
                return(
                    <div className="col-lg-2 col-md-2 col-6 text-center" key={index} style={{padding:20}}>
                        <img src={item} className="avatar avatar-ex-sm" alt=""/>
                    </div>
                )
            })}
        </div>
  )
}
